import {
  ENT_SUPPLIER_LIST, ENT_SUPPLIER_LIST_SUCCESS, ENT_SUPPLIER_LIST_ERROR,
  ENT_SUPPLIER_PAGE_SET,
  ENT_SUPPLIER_SEARCH_CHANGE,
  ENT_SUPPLIER_DETAIL, ENT_SUPPLIER_DETAIL_SUCCESS, ENT_SUPPLIER_DETAIL_ERROR,
  ENT_SUPPLIER_VIEW_MODAL_SET,
} from '../../actions';

const INIT_STATE = {
  loading: false,
  list: { page: { current: 1, rows: 10 }, data: [], total_item: 0, total_pages: 0, first_page: 0, last_items: 0 },
  detail: { loading: false, data: null },
  view: { modal: false },
  search: { data: { name: '' } },
  error: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ENT_SUPPLIER_LIST: return { ...state, loading: true };
    case ENT_SUPPLIER_LIST_SUCCESS: return { ...state, loading: false, list: { ...state.list, ...action.payload } };
    case ENT_SUPPLIER_LIST_ERROR: return { ...state, loading: false, error: true };
    case ENT_SUPPLIER_PAGE_SET: return { ...state, list: { ...state.list, page: { ...state.list.page, ...action.payload } } };
    case ENT_SUPPLIER_SEARCH_CHANGE: return { ...state, search: { ...state.search, data: action.payload } };
    case ENT_SUPPLIER_DETAIL: return { ...state, detail: { ...state.detail, loading: true } };
    case ENT_SUPPLIER_DETAIL_SUCCESS: return { ...state, detail: { loading: false, data: action.payload } };
    case ENT_SUPPLIER_DETAIL_ERROR: return { ...state, detail: { loading: false, data: null } };
    case ENT_SUPPLIER_VIEW_MODAL_SET: return { ...state, view: { ...state.view, modal: action.payload } };
    default: return { ...state };
  }
};
